import { render, staticRenderFns } from "./modal-addnote.vue?vue&type=template&id=124c0daa&scoped=true&"
import script from "./modal-addnote.vue?vue&type=script&lang=js&"
export * from "./modal-addnote.vue?vue&type=script&lang=js&"
import style0 from "./modal-addnote.vue?vue&type=style&index=0&id=124c0daa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124c0daa",
  null
  
)

export default component.exports